import React, { useEffect, useCallback, useState } from "react";
import {
  Modal,
  Box,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Typography,
  IconButton,
  Grid,
  InputAdornment,
  styled,
  FormHelperText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as Yup from "yup";
import getallspecificclient from "../../../../services/offer";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../../../../redux/loader/actions";
import { showSnackbar } from "../../../../redux/snackbar/actions";
import productApi from "../../../../services/product";
import productPricingApi from "../../../../services/product_pricing";
import moment from "moment";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  border: "2px solid #ccc",
  boxShadow: 24,

  maxHeight: "80vh",
  overflowY: "auto",
  p: 4,
  "@media (max-width: 320px)": {
    width: "55%",
    padding: 2,
    top: "279px",
  },
  "@media (max-width: 768px)": {
    width: "81%",
    padding: 2,
    top: "279px",
  },
  ".css-mhc70k-MuiGrid-root .MuiGrid-item": {
    paddingTop: 0,
  },
};

const CustomSelect = styled(Select)(({ theme }) => ({
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "& .MuiSelect-select": {
    padding: "0 8px",
  },
  "& .MuiInputBase-input": {
    display: "flex",
    alignItems: "center",
  },
  "&:before": {
    border: "none",
  },
  "&:after": {
    border: "none",
  },
}));

const CreateVoucherModal = ({
  open,
  onCreate,
  voucherData,
  setVoucherData,
  offerData,
  setOfferData,
  mode,
  setMode,
  setOpenModal,
  fetchUsers,
}) => {
  const dispatch = useDispatch();

  const [clients, setClients] = useState([]);
  const [Product, setProduct] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [clientEmail, setClientEmail] = useState("");
  const [selectedProductUUID, setSelectedProductUUID] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [productList, setProductList] = useState([]);
  const [planDetails, setPlanDetails] = useState([]);
  const [selectedPlanUUID, setSelectedPlanUUID] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [userUUID, setUserUUID] = useState(null);

  const formik = useFormik({
    initialValues: {
      vouchercouponcode: voucherData.vouchercouponcode || "",
      validfrom: voucherData.validfrom || null,
      validto: voucherData.validto || null,
      purposeofvoucher: voucherData.purposeofvoucher || "",
      vouchercupondiscount: voucherData.vouchercupondiscount || "",
      product: voucherData.product || "",
      plans: Array.isArray(voucherData.plans) ? "" : voucherData.plans || "",
      clientname: voucherData.clientname || "",
      clientemail: voucherData.clientemail || "",
      currency: voucherData.currency || "",
    },
    validationSchema: Yup.object({
      currency: Yup.string().required("Discount Type is required"),
      vouchercouponcode: Yup.string().required(
        "Voucher/Coupon Code is required"
      ),
      clientname: Yup.string().required("ClientName is required"),
      clientemail: Yup.string().required("ClientEmail is required"),
      validfrom: Yup.string().required("Valid From is required"),
      validto: Yup.string()
        .required("Valid To is required")
        .test(
          "is-valid-to-date",
          "Valid To must be later than or the same as Valid From",
          function (value) {
            const { validfrom } = this.parent;

            if (!validfrom) {
              return this.createError({
                message: "Valid From must be selected first",
              });
            }

            const validFromDate = new Date(validfrom);
            const validToDate = new Date(value);

            if (validToDate < validFromDate) {
              return this.createError({
                message:
                  "Valid To must be later than or the same as Valid From",
              });
            }
            return true;
          }
        ),

      purposeofvoucher: Yup.string().required(
        "Purpose of Voucher/Coupon is required"
      ),
      vouchercupondiscount: Yup.string()
        .required("Voucher/Coupon Discount is required")
        .test(
          "discount-value",
          "Voucher/Coupon Discount must be a valid number",
          (value) => {
            if (!value) return false;
            if (/^\d+(\.\d+)?$/.test(value) || /^\d+(\.\d+)?%$/.test(value)) {
              return true;
            }
            return false;
          }
        ),
      product: Yup.string().required("Product is required"),
      plans: Yup.string().required("Plan is required"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
  const onClose = () => {
    formik?.resetForm();
    setOpenModal(false);
    setPlanDetails([]);
    setMode();
    setUserUUID();
    setClientEmail();
    setSelectedProductUUID("");
    setSelectedCurrency();
  };

  useEffect(() => {
    if (mode === "edit" && open) {
      formik?.setFieldValue("vouchercouponcode", offerData?.offer_code);
      formik?.setFieldValue("validfrom", offerData?.valid_from);
      formik?.setFieldValue("validto", offerData?.valid_to);
      formik?.setFieldValue("purposeofvoucher", offerData?.offer_description);
      formik?.setFieldValue("vouchercupondiscount", offerData?.offer_discount);
      formik?.setFieldValue("product", offerData?.productDetails?.uuid);
      formik?.setFieldValue(
        "plans",
        offerData?.productPlanDetails?.product_plan_uuid
      );
      formik?.setFieldValue("clientname", offerData?.userDetails?.username);
      formik?.setFieldValue("clientemail", offerData?.userDetails?.email);
      formik?.setFieldValue("currency", offerData?.offer_discount_type);
      setSelectedPlanUUID(offerData?.productPlanDetails?.product_plan_uuid);
      planData(offerData?.productDetails?.uuid);
      setSelectedCurrency(offerData?.offer_discount_type);
      setUserUUID(offerData?.userDetails?.uuid);
      setSelectedProductUUID(offerData?.productDetails?.uuid);
    }
    if (mode === "recreate" && open) {
      formik?.setFieldValue("vouchercouponcode", offerData?.offer_code);
      formik?.setFieldValue("purposeofvoucher", offerData?.offer_description);
      formik?.setFieldValue("vouchercupondiscount", offerData?.offer_discount);
      formik?.setFieldValue("product", offerData?.productDetails?.uuid);
      formik?.setFieldValue(
        "plans",
        offerData?.productPlanDetails?.product_plan_uuid
      );
      formik?.setFieldValue("clientname", offerData?.userDetails?.username);
      formik?.setFieldValue("clientemail", offerData?.userDetails?.email);
      formik?.setFieldValue("currency", offerData?.offer_discount_type);
      setSelectedPlanUUID(offerData?.productPlanDetails?.product_plan_uuid);
      planData(offerData?.productDetails?.uuid);
      setSelectedCurrency(offerData?.offer_discount_type);
      setUserUUID(offerData?.userDetails?.uuid);
      setSelectedProductUUID(offerData?.productDetails?.uuid);
    }
  }, [mode, offerData]);

  const handleDiscountChange = (e) => {
    const value = e.target.value;
    if (selectedCurrency === "percentage") {
      let numberValue = parseFloat(value);
      if (isNaN(numberValue) || numberValue < 0 || numberValue >= 100) {
        if (numberValue >= 100) {
          dispatch(
            showSnackbar({
              message: "Discount cannot be 100% or more than 100%",
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "warning",
            })
          );
          formik.setFieldValue("vouchercupondiscount", "");
        } else {
          formik.setFieldValue("vouchercupondiscount", "");
        }
        return;
      }

      if (value.includes(".") && value.split(".")[1]?.length > 2) {
        formik.setFieldValue(
          "vouchercupondiscount",
          value.substring(0, value.indexOf(".") + 3)
        );
        return;
      }

      formik.setFieldValue("vouchercupondiscount", value);
    } else {
      formik.setFieldValue("vouchercupondiscount", value);
    }
  };
  const handleDateChange = (e, fieldName) => {
    const { value } = e.target;
    const formattedDate = new Date(value).toISOString();

    formik.setFieldValue(fieldName, formattedDate);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    formik.setFieldValue(name, value);
  };
  const handleMultiSelectChange = (name) => (event) => {
    const { value } = event.target;
    formik.setFieldValue(name, value);
  };
  const productSelect = useCallback(() => {
    dispatch(showLoader());
    const data = 35;
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setProductList(res?.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      console.error("Error response:", err);
    };
    productApi.getAllProduct(data).then(onSuccess).catch(onFailure);
  }, [dispatch]);
  useEffect(() => {
    if (open) {
      productSelect();
    }
  }, [open]);

  const getAllspecificClients = useCallback(() => {
    dispatch(showLoader());
    getallspecificclient
      .getAllspecificClients()
      .then((res) => {
        setClients(res?.data?.data);
        if (res.data?.length > 0) {
          setSelectedClient(res.data[0].id);
        }
        dispatch(hideLoader());
      })
      .catch((err) => {
        console.log("Error", err);
        dispatch(hideLoader());
      });
  }, [dispatch]);
  useEffect(() => {
    if (open) {
      getAllspecificClients();
    }
  }, [open, getAllspecificClients]);

  const getEmail = useCallback((data) => {
    dispatch(showLoader());
    const onSuccess = (res) => {
      dispatch(hideLoader());
      setClientEmail(res?.data?.data);
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      console.log("Error", err?.response?.data?.msg);
    };
    getallspecificclient.getAllspecificEmails(data).then(onSuccess, onFailure);
  });
  useEffect(() => {
    if (clientEmail) {
      formik.setFieldValue("clientemail", clientEmail[0]?.email);
      setUserUUID(clientEmail[0]?.uuid);
    }
  }, [clientEmail]);

  const getAllspecificProduct = useCallback(() => {
    dispatch(showLoader());
    getallspecificclient
      .getAllspecificProduct()
      .then((res) => {
        setProduct(res?.data?.data);
        dispatch(hideLoader());
      })
      .catch((err) => {
        console.log("Error", err);
        dispatch(hideLoader());
      });
  }, [dispatch]);

  useEffect(() => {
    if (open) {
      getAllspecificProduct();
    }
  }, [open, getAllspecificProduct]);

  const handleProductChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedProduct(selectedValue);
    formik.setFieldValue("product", selectedValue);
    setSelectedProductUUID(e.target.value);
  };
  const planData = useCallback(
    (selectedProductUUID) => {
      const uuid = selectedProductUUID;
      dispatch(showLoader());
      const onSuccess = (res) => {
        dispatch(hideLoader());
        if (res?.data?.status === true) {
          const data = res?.data?.data;

          if (Array.isArray(data) && data.length === 0) {
            dispatch(
              showSnackbar({
                message: "No plan details available.",
                autoHideDuration: 3000,
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
                variant: "warning",
              })
            );
          } else {
            setPlanDetails(data);
          }
        }
      };
      const onFailure = (err) => {
        dispatch(hideLoader());
        console.error("Error response:", err?.response?.msg);
        if (err?.response?.status === false) {
          setPlanDetails([]);
        }
      };
      productPricingApi
        .getPlanAgainstProduct(uuid, true)
        .then(onSuccess)
        .catch(onFailure);
    },
    [dispatch]
  );
  useEffect(() => {
    if (selectedProductUUID) {
      planData(selectedProductUUID);
    }
  }, [selectedProductUUID, planData]);
  useEffect(() => {
    if (selectedPlanUUID) {
      formik?.setFieldValue("plans", selectedPlanUUID);
    }
  }, [selectedPlanUUID]);

  const handleSubmit = useCallback(
    (data) => {
      dispatch(showLoader());
      const requestData = {
        user_uuid: userUUID,
        offer_code: data.vouchercouponcode,
        valid_from: moment.utc(data.validfrom).startOf("day"),
        valid_to: moment.utc(data.validto).endOf("day"),
        offer_description: data.purposeofvoucher,
        offer_discount: data.vouchercupondiscount,
        product_uuid: selectedProductUUID,
        product_plan_uuid: selectedPlanUUID,
        offer_discount_type: selectedCurrency,
      };
      const onSuccess = (res) => {
        dispatch(hideLoader());
        if (res?.data?.status === true) {
          dispatch(
            showSnackbar({
              message: res?.data?.msg,
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "success",
            })
          );
        }
        formik?.resetForm();
        setMode();
        setUserUUID();
        setClientEmail();
        setSelectedProductUUID("");
        onClose();
        fetchUsers();
        setPlanDetails([]);
        setSelectedCurrency();
      };
      const onFailure = (err) => {
        console.error("Failed to Create Offer", err);
        dispatch(
          showSnackbar({
            message: err?.response?.data?.msg,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "error",
          })
        );
        dispatch(hideLoader());
      };
      if (mode === "edit") {
        getallspecificclient
          .updateSpecificOfferId(offerData?.uuid, requestData)
          .then(onSuccess, onFailure);
      } else {
        getallspecificclient
          .createSpecificoffer(requestData)
          .then(onSuccess, onFailure);
      }
    },
    [dispatch, selectedProductUUID, selectedPlanUUID, userUUID]
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      disableEscapeKeyDown
      BackdropProps={{
        onClick: (e) => e.stopPropagation(),
      }}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box sx={style}>
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 10, right: 10 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h6"
          sx={{
            textAlign: "center",
            marginBottom: "16px",
            "@media (max-width: 600px)": {
              fontSize: "15px",
            },
          }}
        >
          {mode === "edit" ? "Update Voucher/Coupon" : "Create Voucher/Coupon"}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Client Name</InputLabel>
              <Select
                label="Client Name"
                name="clientname"
                required
                value={formik.values.clientname}
                onChange={(e) => {
                  getEmail(e.target.value);
                  formik?.setFieldValue("clientname", e.target.value);
                }}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.clientname && Boolean(formik.errors.clientname)
                }
              >
                {clients?.map((client) => (
                  <MenuItem key={client.username} value={client.username}>
                    {client.username}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.clientname && formik.errors.clientname && (
                <Typography color="error" variant="caption">
                  {formik.errors.clientname}
                </Typography>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            {clientEmail?.length > 1 ? (
              <FormControl
                fullWidth
                margin="normal"
                error={
                  formik.touched.clientemail &&
                  Boolean(formik.errors.clientemail)
                }
              >
                <InputLabel id="clientemail-label">Client Email Id</InputLabel>
                <Select
                  labelId="clientemail-label"
                  label="Client Email Id"
                  name="clientemail"
                  value={formik.values.clientemail}
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    formik.handleChange(e);
                    setUserUUID(e.target.value);
                  }}
                  fullWidth
                >
                  <MenuItem value="" selected>
                    Select
                  </MenuItem>
                  {clientEmail.map((email, index) => (
                    <MenuItem key={index} value={email?.uuid}>
                      {email?.email}
                    </MenuItem>
                  ))}
                </Select>
                {formik.touched.clientemail && formik.errors.clientemail && (
                  <div className="error-text">{formik.errors.clientemail}</div>
                )}
              </FormControl>
            ) : (
              <TextField
                label="Client Email Id"
                name="clientemail"
                value={formik.values.clientemail}
                onBlur={formik.handleBlur}
                fullWidth
                margin="normal"
                error={
                  formik.touched.clientemail &&
                  Boolean(formik.errors.clientemail)
                }
                helperText={
                  formik.touched.clientemail && formik.errors.clientemail
                }
                InputProps={{
                  readOnly: true,
                }}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Valid From"
              type="date"
              name="validfrom"
              value={
                formik.values.validfrom
                  ? formik.values.validfrom.split("T")[0]
                  : ""
              }
              onChange={(e) => handleDateChange(e, "validfrom")}
              onBlur={formik.handleBlur}
              fullWidth
              margin="normal"
              InputLabelProps={{ shrink: true }}
              error={
                formik.touched.validfrom && Boolean(formik.errors.validfrom)
              }
              helperText={formik.touched.validfrom && formik.errors.validfrom}
              inputProps={{
                min: new Date().toISOString().split("T")[0],
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Valid To"
              type="date"
              name="validto"
              value={
                formik.values.validto ? formik.values.validto.split("T")[0] : ""
              }
              onChange={(e) => handleDateChange(e, "validto")}
              onBlur={formik.handleBlur}
              fullWidth
              margin="normal"
              InputLabelProps={{ shrink: true }}
              error={formik.touched.validto && Boolean(formik.errors.validto)}
              helperText={formik.touched.validto && formik.errors.validto}
              inputProps={{
                min: formik.values.validfrom
                  ? formik.values.validfrom.split("T")[0]
                  : new Date().toISOString().split("T")[0],
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Purpose of Voucher"
              name="purposeofvoucher"
              value={formik.values.purposeofvoucher}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              multiline
              fullWidth
              margin="normal"
              error={
                formik.touched.purposeofvoucher &&
                Boolean(formik.errors.purposeofvoucher)
              }
              helperText={
                formik.touched.purposeofvoucher &&
                formik.errors.purposeofvoucher
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Voucher/Coupon Discount"
              name="vouchercupondiscount"
              value={formik.values.vouchercupondiscount || ""}
              onChange={handleDiscountChange}
              fullWidth
              margin="normal"
              error={
                formik.touched.vouchercupondiscount &&
                Boolean(formik.errors.vouchercupondiscount)
              }
              helperText={
                formik.touched.vouchercupondiscount &&
                formik.errors.vouchercupondiscount
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <FormControl
                      variant="standard"
                      size="small"
                      sx={{ marginRight: "8px" }}
                    >
                      <CustomSelect
                        sx={{ padding: "0 !important", border: "none" }}
                        value={formik?.values?.currency}
                        onChange={(e) => {
                          const newCurrency = e.target.value;
                          setSelectedCurrency(newCurrency);
                          formik.setFieldValue("currency", newCurrency);
                        }}
                        name="currency"
                      >
                        <MenuItem value="rupee">₹</MenuItem>
                        <MenuItem value="percentage">%</MenuItem>
                      </CustomSelect>
                      {formik.touched.currency && formik.errors.currency && (
                        <FormHelperText error>
                          {formik.errors.currency}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label="Voucher/Coupon Code"
              name="vouchercouponcode"
              value={formik.values.vouchercouponcode}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
              margin="normal"
              error={
                formik.touched.vouchercouponcode &&
                Boolean(formik.errors.vouchercouponcode)
              }
              helperText={
                formik.touched.vouchercouponcode &&
                formik.errors.vouchercouponcode
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Product</InputLabel>
              <Select
                name="product"
                value={formik.values.product}
                onChange={(e) => {
                  handleProductChange(e);
                }}
                label="Product"
                fullWidth
                error={formik.touched.product && Boolean(formik.errors.product)}
                helperText={formik.touched.product && formik.errors.product}
              >
                <MenuItem value="" disabled>
                  Select a product
                </MenuItem>
                {Product.map((product) => (
                  <MenuItem key={product.uuid} value={product.uuid}>
                    {product.name}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.product && formik.errors.product && (
                <Typography color="error" variant="caption">
                  {formik.errors.product}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Plan</InputLabel>
              <Select
                name="plans"
                value={formik.values.plans}
                error={formik.touched.plans && Boolean(formik.errors.plans)}
                helperText={formik.touched.plans && formik.errors.plans}
                onChange={(e) => {
                  const selectedPlanUUID = e.target.value;
                  setSelectedPlanUUID(selectedPlanUUID);
                }}
                label="Plan"
              >
                {planDetails?.length > 0 ? (
                  planDetails.map((plan) => (
                    <MenuItem
                      key={plan.product_plan_uuid}
                      value={plan.product_plan_uuid}
                    >
                      {plan.product_plan_name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" disabled>
                    No plans available
                  </MenuItem>
                )}
              </Select>

              {formik.touched.plans && formik.errors.plans && (
                <Typography color="error" variant="caption">
                  {formik.errors.plans}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid container justifyContent="flex-end" sx={{ mt: 2 }}>
            <Grid item>
              <Button
                variant="contained"
                onClick={formik.handleSubmit}
                sx={{
                  minWidth: "120px",
                  "@media (max-width: 600px)": {
                    minWidth: "100%",
                  },
                }}
              >
                {mode === "edit" ? "Update" : "Create"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default CreateVoucherModal;
